export function checkImg(url) {
  var imgExt = [".png", ".jpg", ".jpeg", ".bmp", ".gif"]
  var i = url.lastIndexOf(".")
  var ext
  if(i > -1) {
    ext = url.substring(i) 
  }
  var flag = false
  imgExt.map(function(o){
    if(o.match(ext)){
      flag = true
      return
    }
  })
  return flag
}
